module.exports = __webpack_public_path__ + "static/media/CENTRO_AMERICA.de58724b.png";